<template>
    <div class="order">
        <transition name="fade">
            <div class="loading-overlay" v-if="submittingOrder">
                <div class="loading-overlay-text">
                    Submitting your order...
                    <loaders loader="rolling"></loaders>
                </div>
            </div>
        </transition>
        <h1 class="hero-title has-text-centered">
            Checkout
        </h1>

        <div class="review-boxes" v-if="cartLoaded === true">
            <div class="review-box">
                <div class="review-box-title">Your Order</div>
                <div class="review-box-content">
                    <div v-if="cartItems.length > 0">
                        <div class="cart-listing">
                            <div v-for="item in cartItems" class="cart-item">
                                <div class="cart-control" @click="removeFromCart(item.id)">
                                    <icons icon="close"></icons>
                                </div>
                                <div class="cart-description">
                                    {{ item.name }} -
                                    {{ item.description }}
                                </div>
                                <div class="cart-price">
                                    ${{ item.price }}
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div class="cart-total-container">
                            Subtotal:
                            <div class="cart-total"><strong>{{ cartSubTotal | currency }}</strong></div>
                        </div>
                        <div class="cart-total-container" v-if="cartTax > 0">
                            Tax:
                            <div class="cart-total"><strong>{{ cartTax | currency }}</strong></div>
                        </div>
                        <div class="cart-total-container">
                            Shipping:
                            <div class="cart-total"><strong>{{ shipTotal | currency }}</strong></div>
                        </div>
                        <div class="cart-total-container">
                            Total:
                            <div class="cart-total"><strong>{{ cartTotal | currency }}</strong></div>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <div class="review-box">
                <div class="review-box-title">Shipping Information</div>
                <div class="review-box-content container">
                    <div v-if="shippingFilledOut && !editingShipping" class="columns">
                        <div class="column">
                            {{ shippingAddress.first_name }}
                            {{ shippingAddress.last_name }}
                            <br/>
                            {{ shippingAddress.email }}
                            <br/>
                            {{ shippingAddress.phone }}
                            <br/>
                            {{ shippingAddress.address1 }}
                            {{ shippingAddress.address2 }}
                            <br/>
                            {{ shippingAddress.city }},
                            {{ shippingAddress.state }}
                            {{ shippingAddress.zip }}
                            <hr/>
                            <br/>
                            <button class="button btn-sm" @click="editingShipping = true">Edit your information</button>
                            <br/>
                            <br/>
                        </div>
                        <div class="column">
                            <shipping-options></shipping-options>
                        </div>
                    </div>
                    <div v-else>
                        <shipping-form @saved="editingShipping = false"></shipping-form>
                    </div>
                </div>
            </div>
            <br/>
            <div class="review-box" v-if="shippingMethod !== false">
                <div class="review-box-title">Payment</div>
                <div class="review-box-content">
                    <div v-if="$store.state.payment.authorization === false">
                        <div class="paypal-checkout">
                            <paypal currency="USD"
                                    :dev="paypalDev"
                                    :amount="cartTotal"
                                    :create-payment="createPayment"
                                    :authorized-payment="authorizedPayment"
                            ></paypal>
                        </div>
                    </div>
                    <div class="is-5" v-else>
                        <strong>
                            You have authorized {{ cartTotal | currency }} to be transferred via PayPal.
                        </strong>
                        <br/>
                        <br/>
                        Click "Finalize Order" below to place your order and complete the transfer.
                        <br/>
                        You will receive an email confirmation of your order at the email address you supplied to
                        PayPal.
                    </div>
                </div>
            </div>
        </div>
        <div class="has-text-centered" v-if="$store.state.payment.authorization !== false">
            <button class="button btn-important" @click="executePayment()">Finalize Order</button>
        </div>
    </div>
</template>

<style lang="scss">
    .paypal-checkout {
        text-align: center;
    }
</style>

<script>
    import {mapGetters} from "vuex"
    import * as types from "../store/types"
    import axios from "axios"

    export default {
        name: 'Review',
        data() {
            return {
                editingShipping: false,
                submittingOrder: false,
                paypalDev: (typeof window !== 'undefined') ? window.location.href.indexOf('.com') == -1 : true
            }
        },
        computed: mapGetters(['cartLoaded', 'cartItems', 'cartSubTotal', 'cartTotal', 'cartTax', 'shipTotal', 'shippingAddress', 'shippingMethod', 'shippingFilledOut']),
        methods: {
            removeFromCart(id) {
                this.$store.dispatch(types.REMOVE_FROM_CART, id)
            },
            createPayment() {
                return new Promise((resolve, reject) => {
                    axios.post('/api/pp/create', {timeout: 15000}).then(response => {
                        resolve(response)
                    }).catch(error => {
                        reject(error);
                    })
                })
            },
            authorizedPayment(authorization) {
                this.$store.dispatch(types.SET_PAYMENT_AUTHORIZATION, authorization)
            },
            executePayment() {
                this.submittingOrder = true
                this.$store.dispatch(types.PLACE_ORDER).then(data => {
                    this.$router.push({name: 'confirmation'})
                }).catch(error => {
                    this.submittingOrder = false
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Review.vue?fc91f074